<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="progress"></div>
    <div class="module__content">
      <div class="gift-box">
        <div
          v-for="(item, key) in giftData.list"
          :key="key"
          class="gift-item"
        >
          <div class="top">
            <span>预约人数</span>
            <span>{{ item.name }}</span>
          </div>
          <div class="gift" :class="{ finish: item.finish }">
            <div class="image">
              <img :src="getGiftImg(item.icon)" />
            </div>
            <div class="name">{{ item.rewardName }}</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="reward-btn" @click="openReserveDialog"></div>
        <!-- <div class="rule" @click="openRuleDialog">活动规则</div> -->
      </div>
      <div class="character"></div>
    </div>
  </div>
</template>

<script>
import reservationMixins from '@/mixins/home/reservationMixins.js'

export default {
  name: 'PcHomeReservation',
  mixins: [reservationMixins],
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/btns.scss';

.module {
  height: 1020px;

  &__title {
    background-position: center -192px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-610px) translateY(-124px);
    width: 1050px;
    height: 452px;
  }
}

.progress {
  margin-top: 88px;
  width: 100%;
  height: 101px;
  background: url('~@/assets/img/pc/reservation_bg.png') no-repeat;
  background-position: center;
}

.gift-box {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.gift-item {
  display: flex;
  flex-direction: column;
  width: 140px;
  height: 452px;

  &:nth-of-type(3) {
    padding-left: 1px;
  }

  .top {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Noto Serif SC;
    font-weight: bold;

    span:first-child {
      line-height: 20px;
      font-size: 20px;
      color: #453932;
    }

    span:last-child {
      font-size: 24px;
      color: #388176;
    }
  }

  .gift {
    position: relative;
    width: 140px;
    height: 368px;
    background: url('~@/assets/img/pc/gift_bg.png') no-repeat;

    &.finish {
      background-position: -140px;
    }

    .image {
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 121px;
      height: 110px;
      background: url('~@/assets/img/pc/prize_bg.png') no-repeat;

      img {
        width: 100px;
      }
    }

    .name {
      position: absolute;
      top: 176px;
      padding: 0 10px;
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #613811;
      white-space: pre-wrap;
    }
  }
}

.bottom {
  position: absolute;
  top: 464px;
  left: 50%;
  transform: translateX(-22px);
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .rule {
    margin-top: 12px;
    font-size: 20px;
    color: #3479a5;
    cursor: pointer;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #3479a5;
    }
  }
}

.reward-btn {
  width: 198px;
  height: 53px;
  background: $btnsBackgroud;
  background-position: $reservationGiftBtnPos;
  cursor: pointer;

  &:hover {
    background-position: $reservationGiftBtnActivePos;
  }
}

.character {
  position: absolute;
  bottom: -170px;
  right: -518px;
  width: 520px;
  height: 710px;
  background: url('~@/assets/img/pc/character1.png') no-repeat;
}
</style>